import { render, staticRenderFns } from "./Demand.vue?vue&type=template&id=9462cb1c"
import script from "./Demand.vue?vue&type=script&lang=js"
export * from "./Demand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports